import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';
import { semanticNavigationGroups } from '@/lib/semantic-content/navigation';

export default function SemanticFooter() {
  return (
    <footer className="border-t border-border/60 bg-card/40">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {semanticNavigationGroups.map((group) => (
            <div key={group.title} className="space-y-3">
              <div className="text-sm font-semibold text-foreground">{group.title}</div>
              <ul className="space-y-2 text-sm text-muted-foreground">
                {group.items.map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className="transition-colors hover:text-primary">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col gap-3 text-sm text-muted-foreground md:flex-row md:items-center md:justify-between">
          <p>MapleOS is a browser-native AI operating system and application environment built around apps, workflows, and user control.</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/what-is-mapleos" className="transition-colors hover:text-primary">
              What Is MapleOS?
            </Link>
            <Link to="/docs" className="transition-colors hover:text-primary">
              Docs
            </Link>
            <Link to="/mapleos-vs-chatgpt" className="transition-colors hover:text-primary">
              Compare
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
